import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import {ref, watch} from "vue";
import SogRadioButtonGroupItem from "@/shared/ui/types/SogRadioButtonGroupItem";
import SogRadioButton from "@/shared/ui/SogRadioButton.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";

interface Props {
  items: SogRadioButtonGroupItem[],
  modelValue?: string,
  name?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogRadioButtonGroup',
  props: {
    items: {},
    modelValue: { default: undefined },
    name: { default: undefined }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit


const _model = ref(props.modelValue)


watch(_model, (newValue) => {
  emit('update:modelValue', newValue)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexRow, { style: {"justify-content":"flex-start","min-height":"30px"} }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(SogRadioButton, {
          key: item.label,
          modelValue: _model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_model).value = $event)),
          value: item.value,
          label: item.label,
          name: __props.name
        }, null, 8, ["modelValue", "value", "label", "name"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})